import { makeStyles } from '@mui/styles';
import { Box, Button, Grid2, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from '../../../../core/contexts/localization';

const useStyles = makeStyles(() => ({
    popInAnimation: {
        animation: '$popIn 0.8s ease-out',
    },
    '@keyframes popIn': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.3)',
        },
        '50%': {
            opacity: 1,
            transform: 'scale(1.2)',
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1)',
        },
    },
}));

const CodeError = ({ title, message }) => {
    const { t: translate } = useTranslation();
    const classes = useStyles();
    const [showGif, setShowGif] = useState(false);

    if (!title) {
        title = translate('checkout.codeError.missingCode.title');
    }

    if (!message) {
        message = translate('checkout.codeError.missingCode.message');
    }

    useEffect(() => {
        setShowGif(true);
    }, []);

    const marketUrl = process.env.REACT_APP_UTRIPER_MARKET_URL || 'https://experiences.utriper.com';

    return (
        <Grid2 container height="95vh" justifyContent="center" alignItems="center">
            <Box>{showGif && <img className={classes.popInAnimation} src="/logo-with-questions.gif" alt="Loading..." loading="lazy" />}</Box>
            <Box sx={{ width: '50%' }}>
                <Grid2>
                    <Typography variant="h2" component="p">
                        {title}
                    </Typography>
                    <Typography variant="h5" component="p" sx={{ marginTop: '1rem' }}>
                        {message}
                    </Typography>
                </Grid2>
                <Grid2 container spacing={2} mt="1rem">
                    <Button
                        variant="contained"
                        color="info"
                        sx={{ color: 'white' }}
                        component="a"
                        href="mailto:hello@utriper.com"
                    >
                        {translate('checkout.codeError.contactButton')}
                    </Button>
                    <Button
                        variant="contained"
                        color="info"
                        sx={{ color: 'white' }}
                        component="a"
                        href={marketUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {translate('checkout.codeError.linkButton')}
                    </Button>
                </Grid2>
            </Box>
        </Grid2>
    );
};

export default CodeError;
